<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="primary">
      <ion-button (click)="modalController.dismiss()"> {{ 'core.done' | translate }} </ion-button>
    </ion-buttons>

    <ion-title>{{ 'settings.information.changelog' | translate }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  @for (version of versions; track $index) {
    <ion-card>
      <ion-card-header>
        <ion-card-subtitle>{{ version.date | date: 'longDate' : null : getLocale() }}</ion-card-subtitle>
        <ion-card-title>Version {{ version.version }}</ion-card-title>
      </ion-card-header>

      @if (version.description) {
        <ion-card-content [innerHTML]="version.description"></ion-card-content>
      }

      @if (version.changes) {
        <ion-card-content>
          <ul class="list">
            @for (change of version.changes; track $index) {
              <li>{{ change }}</li>
            }
          </ul>
        </ion-card-content>
      }
    </ion-card>
  }
</ion-content>
